import { useQuery } from '@apollo/client';
import { graphql } from '@gql/gql';

export const UNSUBSCRIBE = graphql(`
  query Unsubscribe($cryptedEmail: String!, $contactPreferenceToDisable: String) {
    unsubscribe(
      cryptedEmail: $cryptedEmail
      contactPreferenceToDisable: $contactPreferenceToDisable
    ) {
      email
      contactPreferences
      isRegisteredUser
    }
  }
`);

export const useUnsubscribe = (cryptedEmail: string, contactPreferenceToDisable?: string) => {
  const { data, error, loading } = useQuery(UNSUBSCRIBE, {
    variables: {
      cryptedEmail,
      contactPreferenceToDisable,
    },
  });

  return {
    contactPreferencesData: data?.unsubscribe,
    contactPreferencesError: error,
    contactPreferencesLoading: loading,
  };
};
